import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  site: {},
};

export const siteSlice = createSlice({
  name: 'site',
  initialState,
  reducers: {
    setSite: (state, action) => {
      state.site = action.payload;
    },
    deleteSite: state => {
      state.site = {};
    },
  },
});

export const { setSite, deleteSite } = siteSlice.actions;

export default siteSlice.reducer;
